'use strict';

var cookieConsentConfiguration = {
    cookieName: 'cookie_consent',
    containerId: 'cookie-consent',
    expiryDays: 365,
    hideOnInit: false,
    pushConsentToTagManager: false,
    lazyloading: false,
    lazyloadingTimeout: 120,
};
